import * as React from 'react';
import { ValidationProps } from './types';
import { getValidationStyle } from './validation';

import styles from './validation.scss';

/**
 * Renders a validation summary in a flex layout.
 * Should always be used directly inside a <div> with class="row".
 */
export const FlexValidation: React.FC<ValidationProps> = ({messages}) =>
      Array.isArray(messages) && messages.length  ? (
        <div className={`col-12 ${styles.flexValidation}`}>
          <ul>
          {messages.map((item, index) => (
            <li key={index} className={`${!!item.level && 'list-group-item-' + getValidationStyle(item.level)}`}>
              {`${item.label ? `${item.label}: ` : ''}${item.message}`}
            </li>))}
          </ul>
      </div>) : null;
